import { render } from "./importResults.vue?vue&type=template&id=4b538a0c"
import script from "./importResults.vue?vue&type=script&lang=js"
export * from "./importResults.vue?vue&type=script&lang=js"

import "./importResults.vue?vue&type=style&index=0&id=4b538a0c&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__